import React from "react";
import { Link } from "react-router-dom";
const InfectiousDiseaseAssays = () => {
  return (
    <div className="row">
      <div className="col align-self-center">
        <Link to="/digital-assays/featured-content/infectious-disease-assays">
          <h4>Infectious Disease Assays</h4>
          <p>
            Browse assays for key infectious diseases where Droplet Digital PCR
            offers unmet precision and lab to lab reproducibility.
          </p>
        </Link>
      </div>
    </div>
  );
};

export default InfectiousDiseaseAssays;
